<template>
  <div class="register-box rounded-lg py-8 px-4 lg:p-5 bg-opacity-white lg:h-full max-h-100 w-full">
    <form @submit.prevent="submit">
      <p
        class="mx-0 mb-3 text-base font-bold leading-normal lg:text-lg"
      >{{ $t('messages.general.login_account') }}</p>
      <div class="mt-4 mb-2">
        <div class="w-full py-2">
          <input
            v-model.trim="form.email"
            v-validate="'required|email'"
            class="w-full h-10 pl-6 text-sm font-semibold text-gray-800 bg-transparent border border-solid rounded border-blue-850 focus:border-pink-500 focus:outline-none"
            :placeholder="$t('messages.form.email')"
            type="text"
            name="email"
            autocomplete="off"
          />
          <span class="text-sm text-red-600">{{ errors.first('email') }}</span>
        </div>
        <div class="w-full py-2">
          <div class="relative">
            <input
              v-model.trim="form.password"
              v-validate="'required|min:8'"
              class="w-full h-10 pl-6 text-sm font-semibold text-gray-800 bg-transparent border border-solid rounded border-blue-850 focus:border-pink-500 focus:outline-none"
              :placeholder="$t('messages.form.password')"
              :type="type"
              name="password"
            />
            <div
              class="absolute top-0 right-0 flex items-center h-full px-4 cursor-pointer"
              @click="showPassword"
            >
              <span v-if="iconEye" class="text-lg text-white icon-eye" />
              <span v-else class="text-lg text-gray-600 icon-eye" />
            </div>
          </div>
          <span class="text-sm text-red-600">{{ errors.first('password') }}</span>
        </div>
      </div>
      <div class="w-full mt-1 mb-4">
        <router-link
          class="text-sm font-semibold text-gray-800 no-underline hover:text-gray-900"
          to="/password/email"
        >{{ $t('messages.general.forgot_password') }}</router-link>

        <label class="mt-4 text-sm font-semibold text-gray-800 checkbox">
          {{ $t('messages.general.stay_connected') }}
          <input type="checkbox" />
          <span class="bg-transparent border border-white border-solid checkmark" />
        </label>
      </div>
      <div class="my-4 mb-8">
        <div>
          <input
            class="block w-full h-full px-2 py-2 text-sm font-bold text-center text-white border rounded cursor-pointer bg-jblue-primary hover:bg-white hover:text-jblue-primary focus:outline-none border-jblue-primary"
            type="submit"
            :value="$t('messages.general.log_in')"
          />
          <vue-element-loading
            :active="isLoading"
            spinner="spinner"
            color="#DBDBDB"
            background-color="rgba(255, 255, 255, .5)"
          />
        </div>
        <span
          v-show="authError"
          class="text-sm text-red-600"
        >{{ $t('messages.general.auth_failed') }}</span>
        <span
          v-show="authBanned"
          class="text-sm text-red-600"
        >{{ $t('messages.general.auth_banned') }}</span>
      </div>
      <a href="#" class="block p-0 m-0 text-sm font-semibold text-center text-gray-800 no-underline">
        {{ $t('messages.general.are_you_member') }}
        <router-link
          to="/register"
          class="font-bold text-center cursor-pointer text-jpink-primary hover:text-jpink-secondary"
        >{{ $t('messages.general.sign_up_free') }}</router-link>
      </a>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "LoginBox",
  data: () => ({
    type: "password",
    btnText: "Show Password",
    authError: false,
    authBanned: false,
    iconEye: true,
    form: {
      email: null,
      password: null,
      remember: false
    }
  }),
  computed: {
    ...mapState("auth", ["isLoading"]),
    ...mapState("locale", ["locale"])
  },
  watch: {
    locale() {
      this.$nextTick(() => {
        this.errors.items.forEach(e => {
          if (e.regenerate) {
            e.msg = e.regenerate();
          }
        });
      });
    }
  },
  methods: {
    ...mapActions("auth", ["login"]),

    async submit() {
      const valid = await this.$validator.validateAll();

      if (!valid) {
        this.type = "password";
        this.iconEye = true;
        return;
      }

      const response = await this.login(this.form);

      if (response === "These credentials do not match our records.") {
        this.authBanned = false;
        this.authError = true;
      } else if (response === "This user is banned") {
        this.authError = false;
        this.authBanned = true;
      } else {
        this.authError = false;
        this.authBanned = false;
        this.$router.replace(this.$route.query.redirect || "/profile");
        setTimeout(location.reload, 100);
      }
    },

    showPassword() {
      if (this.type === "password") {
        this.type = "text";
        this.iconEye = false;
      } else {
        this.type = "password";
        this.iconEye = true;
      }
    }
  }
};
</script>
<style lang="scss">
.register-box {
  @media screen and(max-height: 740px) {
    padding: 1.9rem 1.25rem !important;
    margin-bottom: 0!important;
  }
}

.checkbox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 30px;
}

.pt-30 {
  padding-top: 7rem;
}

.max-h-100 {
  max-height: 420px;
}

</style>
